import { Module } from 'vuex';
import { RootState } from '../store';
import { getters } from '../getters/document-edit.getters';
import { mutations } from '../mutations/document-edit.mutations';
import { actions } from '../actions/document-edit.actions';
import { IRecipient } from '@/types/Recipient';
import { ISender } from '@/types/Sender';

export const namespace = 'documentEdit';

export interface DocumentEditState {
  isAddingRecipient: boolean;
  isLoadingRecipients: boolean;
  recipients: IRecipient[];
  isSigning: boolean | number;
  isSigningOrder: boolean | number;
  isLoadingDocument: boolean;
  isSelfsign: boolean | number;
  documentType: string;
  sender: ISender;
  videoId: string;
  isVideo: boolean;
  id?: string;
  activeTab: string;
  error: boolean;
}

export const state: DocumentEditState = {
  isAddingRecipient: false,
  isLoadingRecipients: false,
  recipients: [],
  isSigning: false,
  isSigningOrder: false,
  isLoadingDocument: false,
  isSelfsign: false,
  documentType: 'sales',
  sender: {
    email: '',
    name: '',
    thumbUrl: '',
    senderId: '',
  },
  videoId: '',
  isVideo: false,
  id: '',
  activeTab: 'recipients',
  error: false,
};

const namespaced = true;

export const documentEdit: Module<DocumentEditState, RootState> = {
  actions,
  getters,
  namespaced,
  mutations,
  state,
};
